import React, {useEffect, useRef, useState, useMemo} from 'react'
import PropTypes from "prop-types"
import {
  errorMessage,
  getEffectDependencies,
  getValue,
  isInvalid,
  onBlur,
  onChange
} from "./Component";
import Modal from "./Modal";
import {useTranslation} from "react-i18next";
import TextArea from "./TextArea";
import Button from "./Button";

const AdditionalStatusInfoButton = props => {
  const {t} = useTranslation();
  const [value, setValue] = useState(getValue(props));
  const inputRef = useRef();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    props.focus && inputRef.current?.focus && inputRef.current.focus();
  }, [props.focus]);


  const renderModalContent = () => {
    return (
      <div>
        <section className={"modal-card-body"}>
          {t('message_service_provider') + ": \"" + (props.rejectionReason ? props.rejectionReason : "/") + "\""}
        </section>
        <div className={"modal-card-foot"}>
          <Button
            color="primary"
            label={t('offer.cancel')}
            isOutlined={true}
            onClick={() => {
              setShowPopup(false)
            }}
          />
        </div>
      </div>)
  };


  return (
    <>
    <label
      className={"field has-float-label loadable " + (props.className || "")}>
      <input
        id={props.id}
        name={props.id}
        value={value}
        disabled={props.disabled}
        type={"text"}
        min={props.min}
        max={props.max}
        ref={inputRef}
        placeholder=" "
        maxLength={props.maxLength}
        className={!props.skipValidation && isInvalid(props) ? "is-invalid input" : "input"}
      />
      <span>{props.label}</span>
      {props.icon && (
          <div
            onClick={() => setShowPopup(true)}
            className={`right-decoration fz ${props.icon}`}>
              <div className={"has-tooltip"} data-tooltip={t('click_rejection_reason')}/>
          </div>
      )}

    </label>
      <Modal title={t('reason_for_rejection')}
             className={"status-info-modal"}
             body={renderModalContent()}
             showPopup={showPopup}
             onClose={() => setShowPopup(false)}>
      </Modal>
      </>
  );
}

AdditionalStatusInfoButton.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(["text", "number", "time", "email"]),
  className: PropTypes.string,
  label: PropTypes.string,
  unit: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  numberFormat: PropTypes.shape({
    negative: PropTypes.bool,
    decimalPlaces: PropTypes.number,
  }),
  skipValidation: PropTypes.bool,
  invalidMessage: PropTypes.string,
  formatDecimalNumber: PropTypes.bool,
  modalContent: PropTypes.node
};

AdditionalStatusInfoButton.defaultProps = {
  type: "text",
  numberFormat: {
    negative: true,
    decimalPlaces: 2,
  },
}

export default AdditionalStatusInfoButton
